/* jshint esnext: true */
import { APP_NAME } from '../utils/environment';

const MODULE_NAME = 'ProductObject';
const EVENT_NAMESPACE = `${APP_NAME}.${MODULE_NAME}`;

const EVENT = {
    CLICK: `click.${EVENT_NAMESPACE}`
};

export default class {
    constructor(scene, renderer) {

        this.scene = scene;
        this.renderer = renderer;
        this.basePoint = new THREE.Object3D();

    }

    init() {

    }

    ligths() {

    }

    /**
     * Show 3d object (animation)
     * @return {[type]} [description]
     */
    show() {


    }

    /**
     * hide 3d object (animation)
     * @return {[type]} [description]
     */
    hide() {

    }

    destroy() {
        this.$el.off(`.${EVENT_NAMESPACE}`);
    }
}
